import { Clock3, TrendingDown, TrendingUp } from 'lucide-react'

export default function DashboardMetric({ icon: Icon, label, note, tone = 'gold', trend, value }) {
  const TrendIcon = trend === 'down' ? TrendingDown : TrendingUp
  const trendClass =
    trend === 'down' ? 'text-[#D03B3B]' : trend === 'up' ? 'text-[#1F8A4C]' : 'text-[#5A5147]'
  const iconToneClasses = {
    gold: 'bg-[#F3E8CE] text-[#8A6819]',
    green: 'bg-[#DDF4E7] text-[#1F8A4C]',
    pink: 'bg-[#F8E1E7] text-[#7A5963]',
  }

  return (
    <article className="relative min-h-[110px] overflow-hidden rounded-xl bg-white p-3 sm:min-h-[132px] sm:p-4 shadow-[0_18px_45px_rgba(26,26,26,0.05)]">
      <div
        className={`absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full sm:right-4 sm:top-4 sm:h-9 sm:w-9 ${
          iconToneClasses[tone] || iconToneClasses.gold
        }`}
      >
        <Icon size={16} strokeWidth={2.5} sm:size={18} />
      </div>
      <p className="text-xs font-bold uppercase text-[#5A5147] sm:text-sm">{label}</p>
      <strong className="mt-5 block text-xl font-bold tracking-normal text-[#1A1A1A] sm:mt-7 sm:text-2xl">
        {value}
      </strong>
      <div className={`mt-2 flex items-center gap-1.5 text-[10px] font-bold sm:mt-3 sm:gap-2 sm:text-xs ${trendClass || 'text-[#5A5147]'}`}>
        {trend ? <TrendIcon size={14} strokeWidth={2.8} sm:size={16} /> : <Clock3 size={13} sm:size={15} />}
        <span>{note}</span>
      </div>
    </article>
  )
}
